import { useState } from "react";
import Form from "@/components/common/form/form";
import { authServices } from "services/auth.services";
import { ValveService } from "services/assets-valves.services";
import Model from "@/components/common/model.component";
import { useSwrGet } from "@/utils/use-swr-get";
import ValveForm from "./valveForm";
import LocationModal from "./editLocationModal";
import { useTranslation } from "react-i18next";
import _objI from "@/utils/_objI";
import PageTitle from "components/common/page-title.component";
import * as yup from "yup";

const EditVlaveModal = ({
  setRefresh,
  showModal,
  setShowModal,
  rowData,
  setRowData,
}) => {
  const [showLocationModal, setLocationModal] = useState(false);

  const {
    data: farmData,
    isLoading: farmIsLoading,
    isError: farmIsError,
  } = useSwrGet(
    `/farm/all`,
    process.env.NEXT_PUBLIC_BASE_URL +
      `farms/details/${authServices.userValue.org_id}/`
  );
  const { t } = useTranslation();
  const schema = yup.object({
    farm_id: yup.string().required(),
    item_code: yup.string().required(),
    object_id: yup.string().required(),
    flow_rate_m3_per_h: yup.string().required(),
    installation_date: yup.date().required(),
    efficiency: yup.string().required(),
  });
  const onSubmit = async (data) => {
    data.sensor_id = Number(data.sensor_id) ?? null;
    data.water_source_id = Number(data.water_source_id) || null;
    data.attributes_value = {
      flow_rate_m3_per_h: Number(data.flow_rate_m3_per_h),
      efficiency: Number(data.efficiency),
    };
    data.installation_date = new Date(data.installation_date)
      .toISOString()
      .slice(0, 10);
    delete data.flow_rate_m3_per_h;
    delete data.efficiency;
    let res = await ValveService.editValve(
      {
        ...data,
        farm_id: Number(data.farm_id),
        object_id: Number(data.object_id),
        supplier_id: Number(data.supplier_id) || null,
        content_type: farmData
          ?.filter?.((item) => item.farm_id == data.farm_id)
          ?.map?.((item) =>
            item.farm_type === "tree"
              ? authServices.userValue.content_types
                  ?.filter?.((item) => item.model == "treefieldinfo")
                  ?.find?.((item) => item.id)?.id
              : authServices.userValue.content_types
                  ?.filter?.((item) => item.model == "pivotfieldinfo")
                  ?.find?.((item) => item.id)?.id
          )[0],
      },
      rowData.id
    );
    if (res) {
      setLocationModal(true);
    }
  };

  return (
    _objI(rowData) && (
      <>
        <Model
          width="w-130"
          show={showModal}
          onClose={(e) => {
            setShowModal(false);
            setRowData({});
          }}
        >
          <PageTitle title={t("EditValve")} titletextSize="text-xl" />
          <Form
            schema={schema}
            onSubmit={onSubmit}
            defaultValues={
              _objI(rowData)
                ? {
                    ...rowData,
                    efficiency: rowData.attributes_value.efficiency ?? 0,
                    flow_rate_m3_per_h:
                      rowData.attributes_value.flow_rate_m3_per_h ?? 0,
                  }
                : {
                    ...rowData,
                    efficiency: rowData.attributes_value.efficiency ?? 0,
                    flow_rate_m3_per_h:
                      rowData.attributes_value.flow_rate_m3_per_h ?? 0,
                  }
            }
          >
            <ValveForm passProps icon={""} />
          </Form>
        </Model>
        <LocationModal
          setRefresh={setRefresh}
          showModal={showLocationModal}
          setShowModal={setLocationModal}
          closeMainModal={setShowModal}
          rowData={{ rowData }}
        />
      </>
    )
  );
};
export default EditVlaveModal;
